import menu from './menu2';
import types from '../mutation-types';
import * as actions from '../actions';
import router from'../../router/index.js';
import Vue from 'vue'
import storage from '@/utils/IDC/storage';


let state = {
  'alertshow': false,
  'alertType': 'success', //success, info, danger, warning
  'alertContent': '操作成功',
  'perms': [],
  'permObj': getPermObj(), // 角色权限
  'user': (localStorage.user && localStorage.user !== 'undefined') ? JSON.parse(localStorage.user) : {},
  'login': {
    'status': '',
    'msg': '',
  },
  'logout': {
    'status': '',
    'msg': ''
  },
  'basicDic': {},
  'search': {
    'type': '',
    'params': {
      'idCode': '',
      'idType': '',
      'caseId': ''
    },
    'user': {},
  },
  'switcher': {
    'status': 'hide',
    'row': null,
    'tab': ''
  },
  'searchInfo': {
    'social': false
  },
  'recordLog':{
    'id':0
  },
  //重点人类型
  'keyTypes':[],
  //未签收消息数量
  'signNoticeNum':'',
  // 皮肤默认主题
  'themeColor': localStorage.getItem('themeColor') || 'green',
  'openNewTab' : 'F',
  'infoCenterShow': false, // 信息中心弹窗是否显示
  'isKeyLogin': false, // 是否必须用密码狗登录
  'deviceList': null, // 密码狗集合
  'isVerifyControlPersonOperation': false, //新增布控信息是否需要审核
  areaList: {},
  'statisticalTableData': { //报表管理数据
    value: [],
    index: 0,
    prop: '',
    propData: ''
  },
  firstType:'1',
  backupState:false,
  routeParams:'',
  areas:'',
}

// 获取角色权限
function getPermObj(arr = ('perms' in localStorage && localStorage.perms !== '') ? JSON.parse(localStorage.perms) : []) {
  let obj = {}
  arr.forEach((item) => {
    obj[item.perm] = true
  })
  return obj
}

function updateMenuParam(item){
  //实战工具菜单提取到页面展示
  let route = menu.routeOfPerms[item.perm]
  if(route){
    item.icon = route.meta.icon || 'icon-putongneirong'
    item.path = route.path || item.path
  }
  if(item.perm === 'combat'){
    localStorage.spyToolsMenu = JSON.stringify(item.children)
    item.children = null
  }
  //idc菜单提取到页面展示
  if(item.perm === 'business_idcManager' && item.children.length > 0){
    localStorage.idcManageMenu = JSON.stringify(item.children)
    item.children = null
  }
  return item
}
function updateMenuData(data){
  data.map(item =>{
    if(item.children){
      item.children.map(item =>{
        updateMenuParam(item)
      })
    }else{
      updateMenuParam(item)
    }
  })
}
var timer = null
let mutations = {
  [types.alertToggle](state, options) {
    let alertType = options ? options.alertType : state.alertType
    let alertContent = options ? options.alertContent : state.alertContent
    if (state.alertshow) {
      state.alertshow = true
    } else {
      state.alertshow = !state.alertshow;
    }
    state.alertType = alertType;
    state.alertContent = alertContent;
    clearTimeout(timer)
    timer = setTimeout(() => {
      state.alertshow = false
    }, 3000)
  },
  [types.loginSuccess](state, options) {
    state.login = {
      status: 'success',
      msg: '登录成功',
    }
    state.user = options.user

    //写死用户参数
    // if(!options.user.xPoint){
    //   state.user.xPoint = "113.394818"
    // }
    // if(!options.user.yPoint){
    //   state.user.yPoint = "23.408004"
    // }
    // state.user.isLoadBaiduMap = true
    // state.user.mapTileUrl = 'https://online3.map.bdimg.com'
    // window.BMAP_OFFLINE_SERVER = 'https://online3.map.bdimg.com' //state.user.mapTileUrl


    state.perms = options.perms
    state.permObj = getPermObj(options.perms)
    state.logout = {
      status: '',
      msg: ''
    }
    //getMenuItems(menu.expendItem)
    options.menu.forEach(item =>{
      item = updateMenuParam(item)
      let layout = item.path ? 'common' :''
      item.meta = {
        auth: true,
        icon: item.icon,
        perm: item.perm,
        layout: layout,
        used: item.used,
        menuId: item.id
      }
      if(item.children && item.children.length >0){
        item.children.forEach(childItem =>{
          childItem = updateMenuParam(childItem)
          let lay = 'home'
          let childrenCount = 0
          if(childItem.children){
            childItem.children.forEach(item =>{
              item.used && childrenCount++
            })
            if(childrenCount<5){
              lay='ocolumn'
            }else if(childrenCount<9){
              lay = 'tcolumn'
            }else if(childrenCount<13){
              lay = 'thcolumn'
            }else{
              lay = 'fcolumn'
            }
          }
          childItem.meta = {
            auth: true,
            icon: childItem.icon,
            perm: childItem.perm,
            layout: lay,
            used: childItem.used,
            menuId: childItem.id
          }
          if(childItem.children && childItem.children.length>0){
            childItem.children.map(child =>{
              child = updateMenuParam(child)
              child.meta = {
                auth: true,
                icon: child.icon,
                perm: child.perm,
                used: child.used,
                menuId: child.id
              }
              //updateExpendItem(child)
            })
          }
          //updateExpendItem(childItem)
        })
      }
      //updateExpendItem(item)
    })

    // 别实现了，需求说要展示上次设置的数据项，找了老子半天，摩洛哥本地
    //为了实现重新登录时恢复默认的展示数据项
    // for(let lKey in localStorage){
    //   if(lKey.indexOf('BMap')<0){
    //     localStorage.removeItem(lKey)
    //   }
    // }

    localStorage.login = true
    localStorage.user = JSON.stringify(options.user)
    localStorage.perms = JSON.stringify(options.perms)
    localStorage.menu = JSON.stringify(options.menu)
    let spyMenuData = ('spyToolsMenu' in localStorage && localStorage.spyToolsMenu !== '') ? JSON.parse(localStorage.spyToolsMenu) : [];
    let idcManageData = ('idcManageMenu' in localStorage && localStorage.idcManageMenu !== '') ? JSON.parse(localStorage.idcManageMenu) : [];
    updateMenuData(spyMenuData)
    updateMenuData(idcManageData)
    localStorage.spyToolsMenu = JSON.stringify(spyMenuData)
    localStorage.idcManageMenu = JSON.stringify(idcManageData)
  },

  [types.recordLog](state,options){
    state.recordLog = {
      id:options['id']
    }
  },

  [types.loginFailure](state, options) {
    state.login = {
      status: 'failure',
      msg: options.msg
    }
    state.logout = {
      status: '',
      msg: ''
    }
    localStorage.login = false
    // console.log(router, '======================================= router');
    // if (router.history.pending && router.history.pending.fullPath.indexOf('/account/login') < 0) {
    //   router.push('/account/login')
    // }
  },
  [types.logoutSuccess](state) {
    state.login = {
      status: '',
      msg: ''
    }
    state.logout = {
      status: 'success',
      msg: '退出登录成功'
    }
    localStorage.login = false
    localStorage.pageType=''
  },
  [types.logoutFailure](state, options) {
    state.login = {
      status: '',
      msg: ''
    }
    state.logout = {
      status: 'failure',
      msg: options.msg
    }
    localStorage.login = false
  },
  [types.basicDic](state, options) {
    for (let prop in options) {
      state.basicDic[prop] = options[prop]
    }
  },
  [types.searchIndex](state, opts) {
    state.search.params = {
      'idCode': opts.idCode,
      'idType': opts.idType,
      'caseId': opts.caseId || '',
      'caseName': opts.caseName || '',
      'caseStartTime':opts.caseStartTime || '',
      'caseEndTime':opts.caseEndTime || ''
    }
    state.search.type = opts.type
  },
  [types.searchUser](state, user){
    state.search.user = user
  },
  [types.switcherShow](state, {tab, row}){
    state.switcher.status = 'show'
    state.switcher.row = row
    state.switcher.tab = tab
  },
  [types.switcherHide](state){
    state.switcher.status = 'hide'
    state.switcher.row = null
    state.switcher.tab = 'menu-tab-1'
  },
  [types.setKeyTypes](state,types){
    state.keyTypes = types
  },

  [types.signNotice](state,name){
    state.signNoticeNum = name
  },
  // 皮肤
  [types.themeColor](state,name){
    state.themeColor = name
    localStorage.setItem('themeColor', name);
  },
  // 菜单打开方式
  [types.openNewTab](state,name){
    state.openNewTab = name
  },
  [types.setInfoCenterShow](state, flag) {
    state.infoCenterShow = flag
  },
  [types.setDeviceList](state, value) {
    state.deviceList = value
  },
  [types.setIsKeyLogin](state, value) {
    state.isKeyLogin = value
  },
  [types.setIsVerifyControlPersonOperation](state, flag) {
    state.isVerifyControlPersonOperation = flag
  },
  [types.setAreaList](state, {areaCode, value}) {
    Vue.set(state.areaList, areaCode, value)
    // state.areaList[areaCode] = value
  },
  [types.statisticalTableData](state, {value, index, prop, propData}){
    state.statisticalTableData.value = value || []
    state.statisticalTableData.index = index || 0
    state.statisticalTableData.prop = prop || ''
    state.statisticalTableData.propData = propData || ''
  },
  [types.setFirstType](state,type){
    state.firstType = type
  },
  [types.SET_BACKUP_STATE](state, flag) {
    state.backupState = flag
    storage.set('backupState', flag)
  },
  [types.SET_ROUTE_PARAMS](state,params) {
    state.routeParams = params
    // state.areaList[areaCode] = value
  },
  [types.SET_AREAS](state, areas) {
    state.areas = areas
    storage.set('areas', areas)
  },

}

let common = {
  state,
  mutations,
  actions
}

export default {
  menu,
  common,
}
